import { render } from "./three-model-form.vue?vue&type=template&id=3a0eb408"
import script from "./three-model-form.vue?vue&type=script&lang=js"
export * from "./three-model-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__